import { combineReducers } from 'redux';

import basicSettings from './basicSettings';

export default combineReducers({
  basicSettings,
});
